import { ReactElement, useContext, useEffect, useState } from 'react';
import { StyledInsetMap, StyledClusterNumber } from './InsetMap.styles';
import AppContext from '../../../utils/createContext';
import { MediaQuery } from '../../../styles/mediaQuery';
import staticImage from '../../../assets/images/hawaii.png';
import { Image } from '../../atoms/Image/Image';

export function InsetMap(props: { [x: string]: boolean }): ReactElement {
  const { setGoToHawaii, hawaiiCount, nonstopChecked, originAirport, destinationAirport } =
    useContext(AppContext);
  const handleInsetMapClick = () => {
    setGoToHawaii(true);
  };

  const hawaiiNumber = hawaiiCount.length;

  const [hawaiiConnected, setHawaiiConnected] = useState(false);
  const [hawaiiUnserved, setHawaiiUnserved] = useState(false);
  const [hawaiiNonstop, setHawaiiNonstop] = useState(true);
  const hawaiiAirports = hawaiiCount.map((item) => item.iata_code);

  useEffect(() => {
    if (originAirport.nonstop) {
      const nonstop = hawaiiAirports.some((r) => originAirport.nonstop.includes(r));
      setHawaiiNonstop(nonstop);
    }
    if (originAirport.connected) {
      const connected = hawaiiAirports.some((r) => originAirport.connected.includes(r));
      setHawaiiConnected(connected);
    }
    if (originAirport.unserved) {
      const unserved = hawaiiAirports.some((r) => originAirport.unserved.includes(r));
      setHawaiiUnserved(unserved);
    }
    if (!originAirport.iata_code) {
      setHawaiiConnected(false);
      setHawaiiUnserved(false);
      setHawaiiNonstop(true);
    }
  }, [hawaiiAirports, originAirport]);
  return (
    <StyledInsetMap
      id="Hawaii-inset"
      onClick={handleInsetMapClick}
      data-reverse={props['data-reverse']}
      aria-label="navigate to Hawaii"
      $routeActive={Boolean(originAirport.iata_code && destinationAirport.iata_code)}
    >
      <Image
        alt="Go to Hawaii"
        src={staticImage}
        contain
        source={[
          {
            media: MediaQuery.Small,
            srcset: staticImage,
          },
        ]}
      />
      <StyledClusterNumber
        $isConnected={hawaiiNonstop}
        $isUnserved={
          (hawaiiUnserved && !hawaiiNonstop && !hawaiiConnected) ||
          (!hawaiiNonstop && nonstopChecked)
        }
      >
        {hawaiiNumber}
      </StyledClusterNumber>
    </StyledInsetMap>
  );
}
